import LandingPage from './LandingPage';

export default LandingPage;

export { default as landingPageSlice } from './landingPageSlice';
